<template>
  <div class="containar">
    <div class="clock-contents-block">
        <div class="">
          <div id="barclock" class="clock-previewca barfont" v-bind:class="foreColor">
            <span class="bartime">{{ hours }}:{{ minutes }}<span class="barampm">{{ ampm }}</span></span>
          </div>
        </div>
        <div class="set">
          <h3>グラデーション選択</h3>
          <div class="radio-main">
            <label><input type="radio" value="green" v-model="color" /><div class="green-gradient-background select-gradation"></div></label>
            <label><input type="radio" value="blue" v-model="color" /><div class="blue-gradient-background select-gradation"></div></label>
            <label><input type="radio" value="red" v-model="color" /><div class="red-gradient-background select-gradation"></div></label>
            <label><input type="radio" value="sky" v-model="color" /><div class="sky-gradient-background select-gradation"></div></label>
            <label><input type="radio" value="gray" v-model="color" /><div class="gray-gradient-background select-gradation"></div></label>
          </div>
          <h3>配信ソフト用URL</h3>
          <p>各項目を選択するとURLが自動的に生成されます。</p>
          <p>OBSならば、ソースの「ブラウザ」を追加→下記URLを入力すると表示できます。</p>
          <div class="radio-main">
            <input :value="urlInput + '?color=' + color" id="target" type="text" readonly class="m-form-text" />
            <button @click="copy" class="copy-btn">コピー</button>
          </div>
        </div>
      </div>
  </div>
</template>
<script>
export default {
  name: "app",
  data() {
    return {
      hours: "",
      minutes: "",
      ampm: "",
      color: 'green',
      urlInput:'https://ruri.info/tool/barclock'
    };
  },

  computed: {
    foreColor: function() {
      if (this.color === 'green') {
        return 'green-gradient-background';
      }
      else if (this.color === 'blue') {
        return 'blue-gradient-background';
      }
      else if (this.color === 'red') {
        return 'red-gradient-background';
      }
      else if (this.color === 'sky') {
        return 'sky-gradient-background';
      }
      else if (this.color === 'gray') {
        return 'gray-gradient-background';
      }
      else {
        return '';
      }
    },
  },
  mounted: function () {
    setInterval(this.updateTime, 1000);
  },
  methods: {
    updateTime: function () {
      let currentdate = new Date();
      let hours = currentdate.getHours();
      this.ampm = hours >= 12 ? 'pm' : 'am';
      hours = hours % 12;
      hours = hours ? hours : 12; // 0時は12時として扱う
      this.hours = this.zeroPadding(hours, 2);
      this.minutes = this.zeroPadding(currentdate.getMinutes(), 2);
    },
    zeroPadding: function (num, len) {
      let zero = "";

      // 0の文字列を作成
      for (var i = 0; i < len; i++) {
        zero += "0";
      }

      // zeroの文字列と、数字を結合し、後ろ２文字を返す
      return (zero + num).slice(-len);
    },
    copy () {
      if(navigator.clipboard){
        navigator.clipboard.writeText(this.urlInput + '?color=' + this.color)
        console.log('コピー完了')
        return true
      } else {
        return false
      }
    },
  },
};
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@100..900&display=swap');

p {
  margin: 0;
  padding: 0;
  font-size: 14px;
}
.containar{
  margin: 0 auto;
  max-width: 767px;
}

h3{
  font-size: 14px;
  margin-top: 24px;
}

.clock-contents-block{
  text-align: left;
  display: -webkit-flex;
	display: flex;
	-webkit-flex-wrap: nowrap;
	flex-wrap: nowrap;
	align-items: center;
  margin: 24px auto;
  min-width: 0;
  height: 100%;
}

@media screen and (max-width: 630px) {
  .clock-contents-block{
    display: block;
    margin: 0 auto;
  }

  .set{
    margin-top:24px;
    margin-left: 0px!important;
  }
}


#barclock {
  width: 220px;
  height: 70px;
  padding: 14px 42px 0px 42px;
  margin: 12px;
  border-radius: 100vh;
  color: #fff;
  -webkit-align-self: flex-start;
  align-self: flex-start;
  white-space: nowrap;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
}


.bartime {
  letter-spacing: 0.05em;
  font-size: 52px;
  line-height: 0.75em;
  margin-bottom: 10px;
}

.barampm {
  font-size: 0.7em;
  vertical-align: 2px;
  margin-left: 5px;
}

.set{
  padding: 8px 12px 24px 12px;
  background-color: #FFFEF9;
  border-radius: 10px;
  -webkit-align-self: flex-start;
	align-self: flex-start;
  box-sizing: border-box;
  margin-left: 24px;
}

.select-gradation{
  text-align: center;
  background-color: aliceblue;
  width: -moz-fit-content;
  width: fit-content;
  margin: 0 auto;
  padding: 24px 24px 12px 24px;
  line-height: 1;
  border-radius: 10px;
  margin-right: 12px;
}

.blue-gradient-background {
  background: linear-gradient(260deg,#FBDA61 0%, #FF5ACD 100%);
  background-size: 180% 180%;
  animation: blue-gradient-animation 10s ease infinite;
}

@keyframes blue-gradient-animation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.red-gradient-background {
  background: linear-gradient(43deg,#4158D0 0%, #C850C0 46%, #FFCC70 100%);
  background-size: 180% 180%;
  animation: red-gradient-animation 6s ease infinite;
}

@keyframes red-gradient-animation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
.green-gradient-background {
  background: linear-gradient(256deg,#0093E9 0%,#a1efc6 46%, #80D0C7 100%);
  background-size: 240% 240%;
  animation: green-gradient-animation 10s ease infinite;
}

@keyframes green-gradient-animation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.sky-gradient-background {
  background: linear-gradient(260deg, #D9AFD9 0%, #97D9E1 100%);
  background-size: 240% 240%;
  animation: sky-gradient-animation 12s ease infinite;
}

@keyframes sky-gradient-animation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.gray-gradient-background {
  background: linear-gradient(260deg, #304352 0%, #d7d2cc 100%);
  background-size: 240% 240%;
  animation: sky-gradient-animation 12s ease infinite;
}

@keyframes gray-gradient-animation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.barfont{
  font-family: "Outfit", sans-serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
}

.radio-main{
  display: -webkit-flex;
  display: flex;
  flex-wrap: wrap;
  margin-top:12px;
  box-sizing: border-box;
}

.m-form-text{
  height: 2.4em;
  padding: 0 16px;
  border-radius: 4px;
  border: none;
  box-shadow: 0 0 0 1px #ccc inset;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

.copy-btn{
  background-color: #fff;
  border-radius: 4px;
  border: none;
  box-shadow: 0 0 0 1px #ccc inset;
}

.copy-btn:active{
  -webkit-transform: translateY(4px);
  transform: translateY(4px);
  border-bottom: none;
}
</style>

